// Who runs Frolik. Used by the privacy policy, terms and contact page.
// TODO before launch: replace every [placeholder] with your real details.
// Note: if Frolik is run on a business-like basis in Germany, an Impressum
// (§ 5 DDG, real name + postal address) is legally required; it was removed
// for now at the owner's request.

export const OPERATOR = {
  name: '[Your full name]',
  street: '[Street and house number]',
  city: '[Postcode and city]',
  country: 'Germany',
  email: 'froliking@proton.me',
};

// Data protection authority people can complain to (the one for where the
// operator is based). Berlin is assumed; change it if you live elsewhere.
export const SUPERVISORY_AUTHORITY = {
  name: 'Berliner Beauftragte für Datenschutz und Informationsfreiheit',
  url: 'https://www.datenschutz-berlin.de',
};

export const LEGAL_LAST_UPDATED = '13.10.2026';

export const hasPlaceholders = () => Object.values(OPERATOR).some((value) => /^\[.*\]$/.test(value));
